//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  components: {},
  data() {
    return {
      show: false,
      showPicker: false,

      value: "",
      num: 0,
      columns: ["杭州", "宁波", "温州", "嘉兴", "湖州"]
    };
  },
  methods: {
    showPopup() {
      this.show = true;
    },

    onCancel() {
      this.show = false;
    },

    onConfirm(event) {
      this.value = event;
      this.show = false;
    },

    OnreduceClick() {
      this.controlItem.ControlValue--;
      if (this.controlItem.ControlValue < 0) {
        this.controlItem.ControlValue = 0;
      }
    },

    OnAddClick() {
      this.controlItem.ControlValue++;
    },

    changeNum() {
      if (this.controlItem.ControlValue < 0) {
        this.controlItem.ControlValue = 0;
      }
    }
  },
  created() {
  },
  mounted() {}
};
